import React from 'react';
import Modal from '../../Components/Modal';
import Form, { Actions, Checkboxes, Radio, Money, TextField, Conditional, ULID, RequiredValidator } from '../../Components/Form';
import { usePricingCategory } from '../../Data/PricingCategories';
import Loading from '../../Components/Loading';
import { ulid } from 'ulid';
import Tabs, { Tab } from '../../Components/Containers/Tabs/Tabs';

const AddItems = ({categoryId, isOpen, onSave, existing, onClose}) => {
    return <Modal title="Add Items" isOpen={isOpen} setIsOpen={onClose} dismissible>
        {isOpen && <Inner {...{categoryId, existing, onSave}} />}
    </Modal>
}

const Inner = ({categoryId, existing, onSave}) => {
    const {category, addItem} = usePricingCategory(categoryId, true);

    const saveItems = async (data) => {

        if (data.items) {
            onSave(data.items.map(itemId => {
                const c = category.items.find(it => it.id === itemId)
                return {
                    ...c,
                    unitPrice: c.defaultUnitPrice ?? 0,
                    units: 1,
                }
            }));
        }

        if (data.name) {
            const newItem = {
                pricingItemId: ulid(),
                defaultUnitPrice: data.unitPrice ?? 0,
                units: 1,
                ...data
            };
            await addItem(newItem);
            onSave([newItem]);
        }
    }

    return <>
        <Tabs selected={(category && category?.items?.length === 0) ? 'New' : 'Existing'}>
            <Tab icon="ListCheck" title="Existing">
                <Form onSubmit={saveItems} closeModalOnSubmit>
                    <ExistingItems items={category?.items ?? []} existing={existing ?? []} />
                    <Actions submit={{label: 'Add items'}} cancel />
                </Form>
            </Tab>
            <Tab icon="Plus" title="New">
                <Form onSubmit={saveItems} data={{unitPrice: 0}} closeModalOnSubmit>
                    <ULID name="pricingItemId" />
                    <TextField name="name" label="Name" validators={[RequiredValidator]} />
                    <TextField name="description" label="Description" validators={[]} />
                    <Money name="unitPrice" label="Unit Price" validators={[]} />
                    <Radio layout="SmallCards" name="displayPrice" label="Display price" validators={[RequiredValidator]}
                        options={[
                            {
                                label: 'Total',
                                value: 'Total',
                            },
                            {
                                label: 'Individual',
                                value: 'Individual',
                            },
                        ]}
                        help="Total will show a single price and no unit count, Individual will show the price per unit"
                    />
                    <Conditional condition={formData => formData.displayPrice === 'Individual'}>
                        <TextField type="number" name="units" label="Count" validators={[RequiredValidator]} />
                    </Conditional>
                    <Actions submit={{label: 'Add items'}} cancel />
                </Form>
            </Tab>
        </Tabs>
    </>
}

const ExistingItems = ({items, existing}) => {
    if (items === null) {
        return <Loading size="2x" center />;
    }

    if (items.length === 0) {
        return <p className="text-center text-muted">
            No existing items to add.<br />
            Use the 'New' tab to add a new item, which will be available here next time.
        </p>
    }

    return <>
        <Checkboxes label="Previous Items"
            name="items"
            options={items.filter(c => !existing.find(e => e.id === c.id)).map(c => ({value: c.id, label: c.name}))}
            validators={[RequiredValidator]}
        />
    </>
}

export default AddItems;
